import { Link } from 'react-router-dom';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import AddIconImage from '../../shared/svg/plus.svg';
import CompletedIconImage from '../../shared/svg/check.svg';

import ImageCard from '../../components/ImageCard';

import './index.scss';
import ListPage from '../../layouts/ListPage';

function CollectionsMenu() {

  const profileCompletionChecks = [
    {
      title: 'Cuisines',
      description: ``,
      completed: true,
      uri: '/cuisine'
    },
    {
      title: 'Collections',
      description: ``,
      completed: true,
      uri: '/collections'
    },
    {
      title: 'Authors',
      description: ``,
      completed: true,
      uri: '/authors'
    },
  ];

  return (
    <ListPage
      title={'Collections & Cuisine'}
      description={'View and manage collections and cuisine.'}
      breadcrumbsLinks={[
        {
          url: '/',
          content: 'Content Library',
        },
      ]}
    >
      <Box className="check-icon" sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          {profileCompletionChecks.map((check) => (
            <Grid key={check.title} item xs={6} md={4} lg={3} xl={2}>
              <Link to={check.uri}>
                <ImageCard
                  item={{
                    title: check.title,
                    description: check.description,
                    url: check.completed ? CompletedIconImage : AddIconImage
                  }}
                  icon={true}
                  imageBackground='#fff'
                />
              </Link>
            </Grid>
          ))}
        </Grid>
      </Box>
    </ListPage>
  )
}

export default CollectionsMenu;